import lang from "dojo/_base/lang";
import { compose, mdsWidget } from 'dojo/_base/declare';
import WidgetNavigationMap from "../../moreCore/UI/Navigation/WidgetNavigationMap";
import BlockFinder from "./Block/BlockFinder";
import ConfigurationFinder from "./Configuration/ConfigurationFinder";
import EndpointFinder from "./Endpoint/EndpointFinder";
import ExternalUrlFinder from "./ExternalUrl/ExternalUrlFinder";
import ScenarioFinder from "./Scenario/ScenarioFinder";
import TemplateFinder from "./Template/TemplateFinder";



enum NavigationGroups {

}
enum FeaturePaths {

}

interface recordWithClassnames {

}
class ScreenplayNavigation extends compose(WidgetNavigationMap<{}>) {

    private _onClickUpdateScreenplay() {
        this.showToast({
            ID: "configUpdateToast",
            iconClass: "fas fa-cloud-upload-alt",
            timeout: 180 * 1000,
            title: this.translate("Screenplay_Message_UpdatingData")
        });
        this.RequestManager.callfunction("Webtool_API__Screenplay_UpdateScreenplayData", {}, lang.hitch(this, this._onUpdateScreenplayResponse), lang.hitch(this, this._onUpdateScreenplayResponse));
    }

    private _onUpdateScreenplayResponse(response) {
        this.removeToast("configUpdateToast");
        this.showToast(this.translate("Screenplay_Message_DataUpdateSuccess"), "fas fa-check")
    }

    private _onUpdateScreenplayError(error) {
        this.removeToast("configUpdateToast");
        console.error(error);
        this.showToast(error, "fas fa-times");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.requestContextButton({
            permanent: true,
            label: this.translate("Screenplay_Label_UpdateDataButton"),
            enabled: true,
            name: "updateScreenplay",
            placement: "topmenu",
            iconClass: "fas fa-sync-alt",
            callback: lang.hitch(this, this._onClickUpdateScreenplay)
        });
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setup({
            "ConfigurationFinder": {
                navigationAreaName: "Screenplay__Navigation_SimpleEditor",
                icon: "fas fa-wrench",
                label: "ConfigurationFinder_MainTitle",
                colorClass: "w3-grey",
                roles: ["Screenplay_Configuration"],
                featurepath: "Screenplay/Configuration",
                targetWidget: ConfigurationFinder
            },
            "ExternalUrlFinder": {
                navigationAreaName: "Screenplay__Navigation_SimpleEditor",
                icon: "fas fa-link",
                label: "ExternalUrlFinder_MainTitle",
                colorClass: "w3-red",
                roles: ["Screenplay_ExternalUrl"],
                featurepath: "Screenplay/ExternalUrl",
                targetWidget: ExternalUrlFinder
            },
            "BlockFinder": {
                navigationAreaName: "Screenplay__Navigation_SimpleEditor",
                icon: "fas fa-clipboard-list",
                label: "BlockFinder_MainTitle",
                colorClass: "w3-blue",
                roles: ["Screenplay_Block"],
                featurepath: "Screenplay/Block",
                targetWidget: BlockFinder
            },
            "TemplateFinder": {
                navigationAreaName: "Screenplay__Navigation_SimpleEditor",
                icon: "fas fa-code",
                label: "TemplateFinder_MainTitle",
                colorClass: "w3-orange",
                roles: ["Screenplay_Template"],
                featurepath: "Screenplay/Template",
                targetWidget: TemplateFinder
            },
            "ScenarioFinder": {
                navigationAreaName: "Screenplay__Navigation_ComplexEditor",
                icon: "fas fa-desktop",
                label: "ScenarioFinder_MainTitle",
                colorClass: "w3-green",
                roles: ["Screenplay_Scenario"],
                featurepath: "Screenplay/Scenario",
                targetWidget: ScenarioFinder
            },
            "EndpointFinder": {
                navigationAreaName: "Screenplay__Navigation_ComplexEditor",
                icon: "fas fa-at",
                label: "EndpointFinder_MainTitle",
                colorClass: "w3-yellow",
                roles: ["Screenplay_Endpoint"],
                featurepath: "Screenplay/Endpoint",
                targetWidget: EndpointFinder
            },
        });
    }

}

export default mdsWidget(ScreenplayNavigation);